import React from 'react';
import ReactDom from 'react-dom';

import { Loading, LoadingProps } from './Loading';

let loading_view_open_count = 0;
let container: HTMLDivElement | undefined;
let close_completed = true;

function createContainer() {
  if (!container) {
    container = document.createElement('div');
    container.id = 'loading-container';
    document.body.appendChild(container);
  }
}

function unmountLoadingView() {
  close_completed = true;
  if (container) {
    ReactDom.unmountComponentAtNode(container);
  }
}

/**
 * @public
 */
export const LoadingManager = {
  open: (loadingProps: LoadingProps = {}) => {
    if (typeof document !== 'undefined') {
      loading_view_open_count++;
      if (loading_view_open_count === 1) {
        createContainer();

        if (!close_completed) {
          unmountLoadingView();
        }

        const view = React.createElement(Loading, loadingProps);
        if (container) {
          ReactDom.render(view, container);
        }
      }
    }
  },
  close: () => {
    if (loading_view_open_count > 0 && container) {
      loading_view_open_count--;

      close_completed = false;
      unmountLoadingView();
    }
  },
};
